import run from "../../animate/run";

/**
 *
 * @param {MainClassProps} main
 * @param {Map<String, String>} external
 * @param {String} name
 * @returns
 */
const initExternalClasses = (main, external, name) => {
  if (!external) {
    return;
  }

  for (const [key, value] of external) {
    if (value !== name) {
      continue;
    }

    const trigger = /** @type {TriggerProps} */ (main.store.get(value));
    const parameter = /** @type {DefaultTriggerParameterMapProps} */ (trigger.get("p_target"));

    if (!parameter.get("is-default")) {
      const target = /** @type {Array<any>} */ (parameter.get("value"));
      const element = /** @type {HTMLElement} */ (target[0]);

      if (element.classList.contains(key)) {
        main.isVisible = true;
        run(main.events.get(`classadded:${value}`), "enter");
      }
    }
  }
};

export default initExternalClasses;
